import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9008Handlers = [
  // 多要素認証処理 /kymw9008/checkMfa
  http.post(PlessService.SERVICE.checkMfa.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getRequestListInfo.url, req);
    // return HttpResponse.json(checkMfaSuccess);
    return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const checkMfaSuccess = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}